







"use strict";

function getEnv() {
    let pathParts = window.location.pathname.split("/");
    return {
        origin: location.origin,
        deployType: pathParts[1],
        appName: pathParts[3]
    };
}

function getPageName() {
    let pageName = window.location.pathname.split("?")[0].split("/").slice(-1)[0].split(".")[0];
    return pageName;
}

function getUrl(type, relativePath, fnGetEnv = getEnv) {
    let env = fnGetEnv();
    if (relativePath.length > 0 && relativePath[0] !== "/") {
        relativePath = "/" + relativePath;
    }
    return [env.origin, env.deployType, type].join("/") + relativePath;
}

function getMyUrl(type, relativePath, fnGetEnv = getEnv) {
    let env = fnGetEnv();
    if (relativePath.length > 0 && relativePath[0] !== "/") {
        relativePath = "/" + relativePath;
    }
    return [env.origin, env.deployType, type, env.appName].join("/") + relativePath;
}






function getApiUrl(relativePath) {
    return getUrl("api", relativePath); 
}






function getWebUiUrl(relativePath) {
    return getUrl("static", relativePath); 
}






function getMyApiUrl(relativePath) {
    return getMyUrl("api", relativePath); 
}






function getMyWebUiUrl(relativePath) {
    return getMyUrl("static", relativePath); 
}






function fromQuery(queryStr) {
    if (queryStr[0] === "?") {
        queryStr = queryStr.slice(1);
    }
    return queryStr.split("&").reduce((params, token) => {
        let kv = token.split("=");
        params[kv[0]] = kv[1];
        return params;
    }, {});
}







function toQueryUrl(url, params) {
    let query = Object.entries(params)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join("&");
    let sep = (url.includes("?")) ? "&" : "?";
    return `${url}${sep}${query}`;
}








function addHeader(options, name, value) {
    if (!options) {
        options = {};
    }
    if (!options.headers) {
        options.headers = {};
    }
    if (options.headers[name]) {
        options.headers[name] = [...options.headers[name], value];
    } else {
        options.headers[name] = value;
    }
    return options;
}








function resolveUrl(url) {
    let loc = window.location;
    if (url.startsWith("http://") || url.startsWith("https://")) {
        return url;
    } else if (url.startsWith("//")) {
        return `${loc.protocol}${url}`;
    } else if (url.startsWith("/")) {
        return `${loc.origin}${url}`;
    } else {
        let tokens = loc.href.split("/");
        tokens = tokens.slice(0, tokens.length - 1);
        tokens.push(url);
        return tokens.join("/");
    }
}

module.exports = {
    getUrl, getPageName, getMyUrl, getApiUrl, getWebUiUrl,
    getMyApiUrl, getMyWebUiUrl, fromQuery, toQueryUrl, addHeader, resolveUrl
};
